module.exports = __webpack_public_path__ + "img/Banner-Sijakon-Peralatan.841a4d06.png";